<template>
<div class="chapter">
<div class="inner_page">
<div><a id="ht"></a></div>
<h4 class="halftitle">BARACK OBAMA</h4>
<h4 class="halftitle2">IN HIS OWN WORDS</h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_ht.vue?5d446ba8